/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_AccountSettings_QueryVariables = {
    accountID?: string | null;
};
export type App_AccountSettings_QueryResponse = {
    readonly account: {
        readonly " $fragmentRefs": FragmentRefs<"AccountSettings_account">;
    };
};
export type App_AccountSettings_Query = {
    readonly response: App_AccountSettings_QueryResponse;
    readonly variables: App_AccountSettings_QueryVariables;
};



/*
query App_AccountSettings_Query(
  $accountID: ID
) {
  account(input: {accountID: $accountID}) {
    ...AccountSettings_account
    id
  }
}

fragment AccountSettings_account on Account {
  ...SubscriberBilling_account
  ...Account_account
}

fragment Account_account on Account {
  name
  team {
    id
    firstName
    lastName
    email
    membership {
      role
    }
  }
}

fragment SubscriberBilling_account on Account {
  subscriber {
    defaultMethod {
      brand
      expMonth
      billingName
      expYear
      last4
    }
    currentInvoiceAmount {
      value
      currency
    }
    invoices {
      id
      amountDue
      paid
      dueDate
      startDate
      endDate
      payURL
      pdfURL
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountID"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "accountID",
        "variableName": "accountID"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "App_AccountSettings_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AccountSettings_account"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "App_AccountSettings_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Subscriber",
            "kind": "LinkedField",
            "name": "subscriber",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentMethod",
                "kind": "LinkedField",
                "name": "defaultMethod",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "brand",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billingName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "last4",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "currentInvoiceAmount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Invoice",
                "kind": "LinkedField",
                "name": "invoices",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amountDue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dueDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "payURL",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pdfURL",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountUser",
            "kind": "LinkedField",
            "name": "team",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountMembershipResponse",
                "kind": "LinkedField",
                "name": "membership",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "role",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c6bff5f27589a9f0bf48fa5796cbbf5",
    "id": null,
    "metadata": {},
    "name": "App_AccountSettings_Query",
    "operationKind": "query",
    "text": "query App_AccountSettings_Query(\n  $accountID: ID\n) {\n  account(input: {accountID: $accountID}) {\n    ...AccountSettings_account\n    id\n  }\n}\n\nfragment AccountSettings_account on Account {\n  ...SubscriberBilling_account\n  ...Account_account\n}\n\nfragment Account_account on Account {\n  name\n  team {\n    id\n    firstName\n    lastName\n    email\n    membership {\n      role\n    }\n  }\n}\n\nfragment SubscriberBilling_account on Account {\n  subscriber {\n    defaultMethod {\n      brand\n      expMonth\n      billingName\n      expYear\n      last4\n    }\n    currentInvoiceAmount {\n      value\n      currency\n    }\n    invoices {\n      id\n      amountDue\n      paid\n      dueDate\n      startDate\n      endDate\n      payURL\n      pdfURL\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '7492564222c725e76fc79d66f84ecfd2';
export default node;
